export default {
  FETCH_LINKED_RETAILERS_REQUEST: 'FETCH_LINKED_RETAILERS_REQUEST',
  FETCH_LINKED_RETAILERS_SUCCESS: 'FETCH_LINKED_RETAILERS_SUCCESS',
  FETCH_LINKED_RETAILERS_FAILURE: 'FETCH_LINKED_RETAILERS_FAILURE',

  UPDATE_LINKED_RETAILERS_REQUEST: 'UPDATE_LINKED_RETAILERS_REQUEST',
  UPDATE_LINKED_RETAILERS_SUCCESS: 'UPDATE_LINKED_RETAILERS_SUCCESS',
  UPDATE_LINKED_RETAILERS_FAILURE: 'UPDATE_LINKED_RETAILERS_FAILURE',

  DELETE_LINKED_RETAILERS_REQUEST: 'DELETE_LINKED_RETAILERS_REQUEST',
  DELETE_LINKED_RETAILERS_SUCCESS: 'DELETE_LINKED_RETAILERS_SUCCESS',
  DELETE_LINKED_RETAILERS_FAILURE: 'DELETE_LINKED_RETAILERS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/user/actions/linked-retailers.action-types.js